import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { Popover, TextField } from '@mui/material';
import './ColorPicker.css';

function ColorPicker({ label, value, onChange }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    return (
        <div className="color_picker_container">
            <span className="color_picker_label">{label}</span>

            <div className="color_picker_value">
                <button
                    type="button"
                    className="color_preview"
                    style={{ backgroundColor: value }}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                />

                <TextField
                    className="color_hex_text_filed"
                    size="small"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />
            </div>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div style={{ padding: 16 }}>
                    <HexColorPicker color={value} onChange={onChange} />
                </div>
            </Popover>
        </div>
    );
}

export default ColorPicker;
